<ng-template #template let-row="row">
  <div class="project-stage-cell" [style.color]="PROJECT_STAGE_COLORS[row?.stage]">
    {{ 'Projects.Stage.' + row?.stage | translate }}
  </div>
</ng-template>
